import React from "react";
import videoImg from "../assets/images/modern.mp4"
import {FiCheckCircle} from '../assets/icons/vander'
import '../../node_modules/react-modal-video/css/modal-video.css'

export default function AboutThree(){
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                    <div className="relative overflow-hidden after:content-[''] after:absolute after:inset-0 after:mx-auto after:w-72 after:h-72 after:bg-gradient-to-tl after:to-amber-400 after:from-fuchsia-600 after:blur-[80px] after:rounded-full p-6 bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-slate-800">
                        <div className="relative overflow-hidden rounded-lg shadow-md dark:shadow-gray-800 z-1">
                            <div className="relative">
                                <video autoPlay muted loop>
                                    <source src={videoImg} type="video/mp4"/>
                                </video>
                            </div>
                        </div>
                 
                    </div>

                    <div>
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Transforme suas aulas gravadas em <br/>relatórios estruturados</h3>

                        <ul className="list-none text-slate-400 mt-4">
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Integração com seu sistema</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Relatórios personalizados</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Ganho de escala e produtividade</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Identifique professores menos performáticos</li>
                            <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/> Alertas de anormalidades</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}